import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/sections/PageHero";
import { fetchBlog } from "../lib/api";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog()
      .then((d) => setPosts(d))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div data-testid="blog-page">
      <PageHero
        kicker="/ The Journal"
        title="Field notes from the"
        accent="edge of work."
        breadcrumb={["Journal"]}
        lead="Long-form thinking on capability, talent deployment, growth consulting and the future of how organisations grow."
      />

      <section className="container-wide py-24 md:py-32">
        {loading ? (
          <p data-testid="blog-loading" className="font-mono-cust text-sm text-gray-500">Loading…</p>
        ) : (
          <>
            {featured && (
              <Link to={`/blog/${featured.slug}`} data-testid="blog-featured" className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-24 group">
                <div className="lg:col-span-7 relative h-[320px] md:h-[520px] overflow-hidden">
                  <img src={featured.cover} alt={featured.title} loading="eager" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" />
                </div>
                <div className="lg:col-span-5 flex flex-col justify-end">
                  <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-6">/ Featured · {featured.category}</p>
                  <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95] mb-6 group-hover:translate-x-1 transition-transform">
                    {featured.title}
                  </h2>
                  <p className="text-lg text-ink-muted leading-relaxed mb-6">{featured.excerpt}</p>
                  <div className="flex items-center justify-between border-t border-ink pt-4 text-sm">
                    <span className="text-gray-500 uppercase tracking-[0.2em]">{featured.author}</span>
                    <span className="text-gray-500">{featured.date} · {featured.read_time}</span>
                  </div>
                </div>
              </Link>
            )}

            <div className="border-t border-ink">
              {rest.map((p, i) => (
                <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-item-${i}`} className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 md:py-12 border-b border-ink group hover:bg-[#F3F3F1] transition-colors px-2">
                  <div className="md:col-span-2">
                    <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A]">/ {String(i + 2).padStart(2, "0")}</p>
                    <p className="text-sm text-gray-500 mt-2 uppercase tracking-[0.2em]">{p.category}</p>
                  </div>
                  <div className="md:col-span-7">
                    <h3 className="font-heading text-2xl md:text-3xl tracking-tight mb-3 group-hover:translate-x-1 transition-transform">{p.title}</h3>
                    <p className="text-base text-ink-muted leading-relaxed">{p.excerpt}</p>
                  </div>
                  <div className="md:col-span-3 flex flex-col items-start md:items-end justify-between gap-3">
                    <div className="md:text-right text-sm text-gray-500">
                      <p>{p.date}</p>
                      <p>{p.read_time}</p>
                    </div>
                    <ArrowUpRight className="w-5 h-5 group-hover:text-[#9F381A] transition-colors" />
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default Blog;
